var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1152 14.5659C12.9438 14.5659 12.7867 14.4945 12.658 14.3659L9.25803 10.8802C9.01518 10.6231 9.01518 10.223 9.27228 9.98019C9.52937 9.73736 9.92947 9.73735 10.1723 9.99444L13.5723 13.4944C13.8151 13.7515 13.8151 14.1516 13.5581 14.3945C13.4438 14.5088 13.2723 14.5659 13.1151 14.5659L13.1152 14.5659Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21522 12.0807C3.00094 12.0807 0.400936 9.49498 0.400936 6.32355C0.386786 3.15212 3.00094 0.566406 6.21522 0.566406C9.42951 0.566406 12.0295 3.15212 12.0295 6.32355C12.0295 9.49498 9.41522 12.0807 6.21522 12.0807ZM6.21522 1.83783C3.70096 1.83783 1.65808 3.85204 1.65808 6.32355C1.65808 8.79495 3.70088 10.8093 6.21522 10.8093C8.71522 10.8093 10.7581 8.79495 10.7581 6.32355C10.7582 3.85204 8.71527 1.83783 6.21522 1.83783Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.89f2a479114c6c40b90db20138bfe2d2.svg";
export { ForwardRef as ReactComponent };